export default __webpack_public_path__ + "static/media/plate-min.401cc4e3.png";